import { redirect, createFileRoute } from '@tanstack/react-router';
import { validateRouteRole, type GuardContext } from '@/lib/routing';
import { isFamilyStudent, isStudent } from '@airreading/common';
import { type LoggedInUser } from '@airreading/common/data';

export const Route = createFileRoute('/_layout/books/')({
  beforeLoad: (ctx) => {
    validateRouteRole(isStudent)(ctx);
    const { actingUser } = (ctx as GuardContext).context;
    if (actingUser && isFamilyStudent(actingUser as LoggedInUser)) {
      throw redirect({ to: '/' });
    }
  },
  loader: () => {
    throw redirect({
      to: '/books/part/$partId',
      params: { partId: '6' },
    });
  },
});
